// extracted by mini-css-extract-plugin
export default {"prevRecord":"PrevRecord_prevRecord__9WP2C","prevRecordTitle":"PrevRecord_prevRecordTitle__3hnTI","prevRecordValue":"PrevRecord_prevRecordValue__g16ro"};